import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import { App as Application } from "vue";

import config from "@/config";
import router from "@/router";

export default function useSentry(app: Application) {
  Sentry.init({
    app,
    dsn: config.tracking.sentry.dsn,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", /^voodootune\.voodoo-[^.]+\.io/, /^\//],
      }),
    ],
    logErrors: true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}
